import { render } from "./AddQuestionType.vue?vue&type=template&id=4b45c109"
import script from "./AddQuestionType.vue?vue&type=script&lang=js"
export * from "./AddQuestionType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__